import { FoundItLink } from "@/types/foundIt";

/**
 * Formats foundIt links data for analytics by sorting by Order and joining AnchorText values.
 * @param {Array} foundItLinks - Array of foundIt links with AnchorText and Order properties
 * @returns {string|undefined} Pipe-separated string of foundIt link names, or undefined if no valid links
 */
export const formatFoundItLinksForAnalytics = (
  foundItLinks: FoundItLink[] | undefined | null,
) => {
  if (
    !foundItLinks ||
    !Array.isArray(foundItLinks) ||
    foundItLinks.length === 0
  ) {
    return undefined;
  }

  return foundItLinks
    .filter((link) => link?.AnchorText)
    .sort((a, b) => (a.Order || 0) - (b.Order || 0))
    .map((link) => link.AnchorText)
    .join("|");
};
